import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CardBody } from 'reactstrap';
import { OAuthApp, OAuthAuthorization } from '../../../../APIClient';
import { MaterialIcon } from '../../../../components';
import { useTranslation } from '../../../../translations';
import { OAuthContainer } from './Container';

interface AuthorizedProps {
  readonly app: OAuthApp;
  readonly authorization: OAuthAuthorization;
}

export const Authorized: FC<AuthorizedProps> = ({ app, authorization }) => {
  const { ts } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      const { redirectUri, token } = authorization;
      const params = new URLSearchParams(location.search);

      window.location.replace(
        `${redirectUri}?code=${encodeURIComponent(token)}&state=${params.get('state')!}`,
      );
    }, 1000);
  }, []);

  return (
    <OAuthContainer app={app}>
      <CardBody className="text-center">
        <MaterialIcon className="override" large name="check_circle" type="success" />
        <h4>{ts('authorized')}</h4>
        <div>
          {ts('just_a_moment_while_we_redirect_you_back_toappname')}: <strong>{app.name}</strong>.
        </div>
      </CardBody>
    </OAuthContainer>
  );
};
